interface CurrencyProps {
  value: number;
  includeDecimals?: boolean;
}
export const Currency = ({ value, includeDecimals = false }: CurrencyProps) => {
  const lengthBeforePoint = `${value}`.split('.')[0].length;

  return (
    <>
      {Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        maximumSignificantDigits: includeDecimals
          ? lengthBeforePoint + 2
          : lengthBeforePoint,
      }).format(value)}
    </>
  );
};

export default Currency;
